/* FlightSimBuilder — product inquiry modals (invoice / question / consultation).
   Forms POST natively to /contact (same proven path as snippets/request-quote.liquid),
   so submission still works if this script fails to load. This file only adds the
   overlay behaviour, deep links, spam guard and success routing. */
(function () {
  'use strict';

  var SS_KEY = 'fsbqSubmittedForm';
  var MIN_DWELL_MS = 2500; // a human needs at least this long to fill the form

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-fsbq-root]');
    if (!root) return;

    var overlays = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-fsbq-form]'), function (el) {
      overlays[el.getAttribute('data-fsbq-form')] = el;
    });
    if (!Object.keys(overlays).length) return;

    // Reparent the overlays to <body>. Dawn renders this block inside
    // .product__info-container (position:sticky, z-index:2) whose wrapper carries a
    // transform. The sticky z-index traps our z-index below the sticky header, and the
    // transform makes the wrapper the containing block for position:fixed — so the
    // overlay sizes to the column instead of the viewport. Neither can be fixed from
    // inside; the element has to leave that subtree.
    Array.prototype.forEach.call(
      document.querySelectorAll('body > [data-fsbq-form][data-fsbq-moved]'),
      function (stale) {
        // Theme editor re-renders the section; drop overlays moved by a previous run.
        if (stale.parentNode) stale.parentNode.removeChild(stale);
      }
    );
    Object.keys(overlays).forEach(function (key) {
      overlays[key].setAttribute('data-fsbq-moved', '');
      document.body.appendChild(overlays[key]);
    });

    var openKey = null;
    var lastFocused = null;
    var scrollLocked = false;

    /* ---------- open / close ---------- */

    function lockScroll() {
      if (scrollLocked) return;
      document.body.dataset.fsbqPrevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      scrollLocked = true;
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      document.body.style.overflow = document.body.dataset.fsbqPrevOverflow || '';
      delete document.body.dataset.fsbqPrevOverflow;
      scrollLocked = false;
    }

    function open(key, focusFirst) {
      var overlay = overlays[key];
      if (!overlay || openKey === key) return;
      if (openKey) close(true);

      lastFocused = document.activeElement;
      openKey = key;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.dataset.fsbqOpenedAt = String(Date.now());
      lockScroll();

      var dialog = overlay.querySelector('.fsbq-modal');
      if (dialog) dialog.scrollTop = 0;

      if (focusFirst !== false) {
        window.setTimeout(function () {
          // Focus the dialog itself, not the first field: focusing an input
          // scrolls the modal body and hides the title, and screen readers
          // should hear the dialog name before the first control.
          var target = overlay.querySelector('.fsbq-error') || dialog;
          if (target) {
            try { target.focus(); } catch (e) { /* noop */ }
          }
          if (dialog) dialog.scrollTop = 0;
        }, 60);
      }
    }

    function close(silent) {
      if (!openKey) return;
      var overlay = overlays[openKey];
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      openKey = null;
      if (!silent) {
        unlockScroll();
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }
    }

    /* ---------- triggers ---------- */

    Array.prototype.forEach.call(root.querySelectorAll('[data-fsbq-open]'), function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        open(btn.getAttribute('data-fsbq-open'));
      });
    });

    Object.keys(overlays).forEach(function (key) {
      var overlay = overlays[key];

      // Backdrop click (but not clicks inside the dialog)
      overlay.addEventListener('mousedown', function (event) {
        if (event.target === overlay) close();
      });

      Array.prototype.forEach.call(overlay.querySelectorAll('[data-fsbq-close]'), function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          close();
        });
      });
    });

    /* ---------- keyboard: escape + focus trap ---------- */

    document.addEventListener('keydown', function (event) {
      if (!openKey) return;
      var overlay = overlays[openKey];

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.filter.call(
        overlay.querySelectorAll(
          'a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ),
        function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        }
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* ---------- submit: spam guard + remember which form ---------- */

    Object.keys(overlays).forEach(function (key) {
      // .fsbq-form only: the consultation modal holds a /cart/add form that must
      // never be delayed by the dwell check or relabelled 'Sending…'.
      var form = overlays[key].querySelector('form.fsbq-form');
      if (!form) return;

      form.addEventListener('submit', function (event) {
        var honeypot = form.querySelector('.fsbq-hp input');
        var openedAt = Number(overlays[key].dataset.fsbqOpenedAt || 0);
        var tooFast = openedAt && Date.now() - openedAt < MIN_DWELL_MS;

        if ((honeypot && honeypot.value !== '') || tooFast) {
          event.preventDefault();
          return;
        }

        try { window.sessionStorage.setItem(SS_KEY, key); } catch (e) { /* private mode */ }

        var submit = form.querySelector('.fsbq-submit');
        if (submit) {
          submit.disabled = true;
          submit.dataset.fsbqLabel = submit.textContent;
          submit.textContent = 'Sending…';
        }
      });
    });

    /* ---------- restore state after the /contact round trip ---------- */

    function storedKey() {
      try { return window.sessionStorage.getItem(SS_KEY); } catch (e) { return null; }
    }

    function clearStoredKey() {
      try { window.sessionStorage.removeItem(SS_KEY); } catch (e) { /* noop */ }
    }

    var params = new URLSearchParams(window.location.search);
    var posted = root.getAttribute('data-fsbq-posted') === 'true' || params.get('contact_posted') === 'true';
    var erroredKey = null;
    Object.keys(overlays).forEach(function (key) {
      if (!erroredKey && overlays[key].querySelector('.fsbq-error')) erroredKey = key;
    });

    if (erroredKey) {
      // Shopify re-renders every contact form on the page with the same errors,
      // so trust the remembered key first and fall back to DOM order.
      var errKey = storedKey();
      if (!errKey || !overlays[errKey]) errKey = erroredKey;
      if (overlays[errKey]) open(errKey);
      clearStoredKey();
    } else if (posted) {
      var key = storedKey();
      if (key && overlays[key]) {
        var success = overlays[key].querySelector('.fsbq-success');
        var form = overlays[key].querySelector('.fsbq-form');
        if (success) success.classList.add('is-active');
        if (form) form.classList.add('is-hidden');
        open(key);
      }
      clearStoredKey();

      // Drop contact_posted so a refresh doesn't replay the confirmation.
      if (params.get('contact_posted') && window.history.replaceState) {
        params.delete('contact_posted');
        var qs = params.toString();
        window.history.replaceState(
          {},
          '',
          window.location.pathname + (qs ? '?' + qs : '') + window.location.hash
        );
      }
    } else {
      // Deep link: /products/handle?fsb_form=invoice
      var deep = params.get('fsb_form');
      if (deep && overlays[deep]) open(deep);
    }
  });
})();
